<template>
  <div>
    <!-- 类型1 -->
    <template v-if="type === 1">
      <div class="title">{{ getData.name }}</div>
      <div class="extra-list-warp">
        <template v-for="(item, index) in getData.extra_list">
          <div
            class="extra-item"
            :key="index"
            :class="{ active: value && item.name == value.name }"
          >
            <div @click="change(item)">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </template>
      </div>
    </template>

    <!-- 类型2 -->
    <template v-if="type === 2">
      <div class="extra-checkbox-warp title">
        <span class="">
          {{ getData.name }}
        </span>

        <checkbox
          shape="square"
          checked-color="#5bad70"
          v-model="ischeckbox"
          @change="checkboxChange"
        ></checkbox>
      </div>
    </template>

    <!-- 类型3 -->
    <template v-if="type === 3">
      <div class="title">
        {{ getData.name }}
      </div>
      <ul class="extra-bar-warp">
        <li
          class="extra-bar-item"
          :class="{ active: value[index].qty > 0 }"
          v-for="(item,index) in getData['extra_list']"
          :key="item.name"
        >
          {{ item.name }}
          <stepper @change="numchange(value[index])" v-model="value[index].qty" :min="item['min_number'] || 0" :max="item['max_number']" disable-input></stepper>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { Checkbox, stepper } from "vant";

export default {
  props: ["data","rules"],
  data() {
    return {
      ischeckbox: 0,
      type: null, //1选择 2复选框 3多选
      value: null,
    };
  },
  created() {
    this.initVal();
  },
  methods: {
    numchange(v){
      var num = 0;
      for(var item of this.value){
        num += item['qty'];
      }
     

      if(this.getData['group_min_mumber']>num){
        v['qty']+=1;
      }else if(this.getData['group_max_number']<num){
        
        this.$msg("每组不能超过"+this.getData['group_max_number']);
        this.$nextTick(()=>{
          v['qty']-=1;
        })
      }
      
    },
    initVal() {
      // 展示类型
      var type = this.data["display_type"];
      if (type == "text" || type == "band" || type == "picture") {
        this.type = 1;
        // 找到默认值
        var _defaultVal = this.data["extra_list"].find(
          (d) => d["is_default"] == 1
        );
        if (_defaultVal) {
          this.value = this.getVal(_defaultVal);
        }
      } else if (type == "checkbox") {
        this.type = 2;
      } else if (type == "bar") {
        this.type = 3;
        this.value = this.data["extra_list"].map((d) => {
          return this.getVal(d, d["is_default"]);
        });
      }
    },
    /**
     * value数据给是
     * qty默认1
     */
    getVal(d, qty) {
      

      qty = qty ?? 1;

      // var _rule = this.rules.find(d=>d['group_name'] == this.data.name);
      // if(_rule){
        
      //   // var item = _rule.find(item=>item['name'] == d['name']);
      //   // console.log(item,"========")
      // }

      return {
        attribute:d['attribute'],
        title: this.data.name,
        id: d["id"],
        extra_sku: d["extra_sku"] || d["code"],
        name: d["name"],
        price: Number(d["price"]) || 0,
        qty: qty ?? 1,
      };
    },
    // 复选
    checkboxChange(v) {
      if (v) {
        this.value = this.getVal(this.data["extra_list"][0]);
      } else {
        this.value = false;
      }
    },
    change(d) {
      var _val = this.getVal(d);
      //0非必选 1必选
      if (
        this.data.must == 0 &&
        this.value &&
        this.value["extra_sku"] === _val["extra_sku"]
      ) {
        this.value = null;
      } else {
        this.value = _val;
      }
    },
  },
  watch: {
    value: {
      handler() {
        this.$emit("change", this.value);
      },
      deep: true,
    },
  },
  computed:{
    getData(){
      var data = JSON.parse(JSON.stringify(this.data))
      var rules = JSON.parse(JSON.stringify(this.rules))

      if(rules){
        var item = rules.find(d=>d['group_name'] == data['name']);
        Object.assign(data,item);
        if(item){
          for(var extraitem of data['extra_list']){
            Object.assign(extraitem,item['group_detail_rules'].find(d=>d['group_detail_code'] ==(extraitem['extra_sku'] || extraitem['code'])))
          }
        }
      }
      
      return data;
    },
    getrules(){
      var _List = this.rules.find(d=>d['group_name'] == this.data['name']);
      return _List;
    }
  },
  components: {
    Checkbox,
    stepper,
  },
};
</script>

<style lang="scss" scoped>
.extra-list-warp {
  margin: 0 -10px;
  display: flex;
  flex-wrap: wrap;

  .extra-item {
    width: 33.33333%;
    padding: 10px;

    & > div {
        width: 100%;
        height: 100%;
      padding: 20px 10px;
      text-align: center;
      border-radius: 8px;
      
      font-size: 24px;
      border:1px solid #f1f1f1;
      color: #999;

      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
    }

    &.active > div {
        border-color:#f1f1f1;
      background: #f1f1f1;
      font-weight: bold;
      color: #333;
    }
  }
}

.extra-checkbox-warp {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.extra-bar-warp {
  .extra-bar-item {
    border: 1px solid #ddd;
    line-height: 88px;
    height: 88px;
    padding: 0 20px;
    margin-bottom: 20px;
    border-radius: 16px;

    display: flex;
    align-content: center;
    justify-content: space-between;

    &.active {
      border-color: #5bad70;
      background: #5bad70;
      color: #fff;
    }
  }
}
</style>